import React, { useEffect, useState } from 'react'
import { FlatList, View, Platform, Dimensions, ScrollView } from 'react-native'

import PropTypes from 'prop-types';

import { VFScreen, TabView, VFText } from '@vfgroup-oneplatform/foundation/Components';

import FrameworkTestKeys from '../../FrameworkTestKeys';


import styles from './AppSettings.Styles';
import SectionItem from './Components/AppSetting';

import { useNavigation, useRoute } from '@react-navigation/native'
import ReduxCache from '../../../../../App/Utils/ReduxCache'
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

function AppSettings({ onClose, withTray, title, settings, images, headerSettingTab, SETTINGS, ...rest }) {
  const { name: _name } = useRoute()
  const { goBack } = useNavigation()
  const theme = useTheme()

  let headerButtons
  if (['ManageProfile', 'EditProfile', 'ChangeMyPassword', 'DeactivateAccount', 'Recommendations', 'Preferences', 'DataManagment', 'TermsAndConditions', 'PrivacyPolicy'].filter((item) => item == _name).length > 0) {
    headerButtons = {
      onClose: onClose,
      showBack: true,
      onBack: goBack,
      showClose: false
    }
  } else {
    headerButtons = {
      onClose: onClose,
    }
  }

  const renderTab = (theme) => {
    const data = _name == 'Settings' ? SETTINGS[rest?.activeTab] : settings
    return (
      <>
        {
          data?.map((item, index) => {
            return (
              <SectionItem
                setting={item}
                index={index}
                images={images}
                theme={theme}
              />
            )
          })
        }
        {/* <FlatList
              testID="appSettingsScroll"
              showsVerticalScrollIndicator={false}
              contentContainerStyle={[
                styles.scrollViewContentContainer,
                withTray && styles.scrollViewContentContainerWithTray
              ]}
              data={data}
              renderItem={(data) => (
                <SectionItem
                  setting={data.item}
                  index={data.index}
                  images={images}
                />
              )}
            /> */}
      </>
    )
  }

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    const styles = () => {
      const tempStyles = {}
      if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
        tempStyles.position = 'initial'
        if (ReduxCache.getUserType() === 'guest') {
          tempStyles.width = '100%'
        }
      }
      return tempStyles
    }
    return (
      <VFScreen
        title={title}
        closeButtonTestID={'appSettingsCloseBtn'}
        headerStyle={styles()}
        {...headerButtons}
        {...rest}
      >
        {/* <View
              style={{
                flex: 1,
                paddingHorizontal: '10%'
              }}
            >
              <FlatList
                testID="appSettingsScroll"
                showsVerticalScrollIndicator={false}
                contentContainerStyle={[
                  styles.scrollViewContentContainer,
                  withTray && styles.scrollViewContentContainerWithTray
                ]}
                data={settings}
                renderItem={(data) => (
                  <SectionItem
                    setting={data.item}
                    index={data.index}
                    images={images}
                  />
                )}
              />
            </View> */}
        <ScrollView contentContainerStyle={{ paddingHorizontal: '10%', paddingBottom: '15%', paddingTop: 64 }}>
          {renderTab(theme)}
        </ScrollView>
      </VFScreen>
    )
  }


  return (
    <VFScreen
      title={title}
      onClose={onClose}
      closeButtonTestID={FrameworkTestKeys.AppSettingsCloseBtn}
      testID={FrameworkTestKeys.appSettingsVFScreen}
      headerStyle={{
        ...Platform.select({
          web: {
            position: 'initial'
          },
          default: {
          }
        }),
      }}
    >
      <View
        style={{
          flex: 1,
        }}
      >
        <FlatList
          testID="appSettingsScroll"
          showsVerticalScrollIndicator={false}
          contentContainerStyle={[
            styles.scrollViewContentContainer,
            withTray && styles.scrollViewContentContainerWithTray
          ]}
          data={settings}
          renderItem={(data) => (
            <SectionItem
              setting={data.item}
              index={data.index}
              images={images}
            />
          )}
        />
      </View>
    </VFScreen>
  );
}

AppSettings.propTypes = {
  title: PropTypes.string,
  settings: PropTypes.array.isRequired,
  withTray: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  images: PropTypes.object,
};

export default AppSettings;
